<template>
  <div class>
    <Nav></Nav>
    <mdb-container class="mt-5">
      <mdb-row class="mb-4">
        <mdb-col class="text-left"></mdb-col>
      </mdb-row>
      <mdb-row class>
        <mdb-col sm="12" md="4" xl="2" class>
          <img
            v-if="getUserPhotourl != '' "
            v-bind:src="getUserPhotourl"
            class="img-fluid rounded-circle z-depth-0"
            alt="avatar image"
            width="100px"
          />
          <div v-else class="avatar-big mb-4">
            <span>{{twoLettersCircleInterior}}</span>
          </div>
          <h3 class>{{usernameBigLabel}}</h3>
          <div class="mb-4">Joined {{userJoinedDateFromProfile}}</div>
          <router-link to="/profile/edit">
            <mdb-btn color="primary" class="sm m-0 outline" rounded>Edit profile</mdb-btn>
          </router-link>
        </mdb-col>
        <mdb-col sm="12" md="8" xl="10" class="progress-list">
          <h2 class="mb-4 mt-4 h2-section">Your progress</h2>

          <div
            v-for="(item,index) in this.yourProgressData"
            :key="'progressdiv'+index"
            class="mb-4 d-flex"
          >
            <router-link :to="mthConstructLinkToCourse(item.courseSlug)" class="bg w-100">
              <!--<img :src="yourProgressImages[index]" class="img-fluid" alt="Responsive image" />-->

              <mdb-card class="box-gradient-white-2 left-bar-purple">
                <!--<mdb-card-image :src="getPhotoUrlByMcName(mc.mcname)" alt="Card image cap"></mdb-card-image>-->
                <mdb-card-body>
                  <div class="video-course text-middleGrey uppercase">
                    <mdb-icon icon="video" />
                    <span>Course</span>
                  </div>
                  <div class="offset-left">
                    <mdb-card-title class="mb-1">{{item.courseFriendlyName}}</mdb-card-title>
                    <!--<ScoreToGapVisualizer :score="mc.mcyourscore"></ScoreToGapVisualizer>
                   <mdb-badge pill :color="getColorByScore(mc.mcyourscore)" class="score">
                    <strong>{{getGradeByScore(mc.mcyourscore)}}</strong>
                    </mdb-badge>-->

                    <!--<mdb-card-text>{{getTextByMcName(mc.mcname)}}</mdb-card-text>-->
                  </div>
                </mdb-card-body>
                <mdb-card-footer small muted class="pt-2">
                  <span class="text-grey ml-2">
                    <mdb-progress
                      v-if="mthGetProgress(item.courseSlug)>0"
                      :height="5"
                      :value="mthGetProgress(item.courseSlug)"
                      class="mt-2"
                    />
                    <mdb-badge
                      v-if="mthGetProgress(item.courseSlug)>97"
                      pill
                      color="bg-green"
                      class
                    >COMPLETED</mdb-badge>
                    <template v-else>
                      <span v-if="mthGetProgress(item.courseSlug)>0" class="text-purple">
                        {{
                        Math.round(mthGetProgress(item.courseSlug))}}%
                      </span>
                    </template>
                  </span>

                  <span class="learn">
                    Start learning
                    <mdb-icon icon="angle-double-right" />
                  </span>
                </mdb-card-footer>
              </mdb-card>

              <!--<div class="progress-list-item-main">
                <h5 class="uppercase">{{item.courseFriendlyName}}</h5>
                <div class="progress-list-item-line">
                  <mdb-badge
                    v-if="mthGetProgressBySlug(item.courseSlug)>97"
                    pill
                    color="bg-green"
                    class
                  >COMPLETED</mdb-badge>
                  <template v-else>
                    <span
                      v-if="mthGetProgressBySlug(item.courseSlug)>0"
                      class="text-purple"
                    >{{Math.round(mthGetProgressBySlug(item.courseSlug))}}%</span>
                    <mdb-progress
                      v-if="mthGetProgressBySlug(item.courseSlug)>0"
                      :height="5"
                      :value="mthGetProgressBySlug(item.courseSlug)"
                    />
                  </template>
                </div>
                Hello
              </div>-->
            </router-link>
          </div>

          <!-- <div class="progress-list-item">
            <router-link to="/">
              <img
                src="https://appen.nazwa.pl/hardlight/projekty/ex2/listening.jpg"
                class="img-fluid"
                alt="Responsive image"
              />
              <div class="progress-list-item-main">
                <h5 class="uppercase">How to sell to existing clients</h5>
                <div class="progress-list-item-line">
                  <mdb-badge pill color="bg-green" class>COMPLETED</mdb-badge>
                </div>
              </div>
            </router-link>
          </div>
          <div class="progress-list-item">
            <router-link to="/">
              <img
                src="https://appen.nazwa.pl/hardlight/projekty/ex2/presentation.jpg"
                class="img-fluid"
                alt="Responsive image"
              />
              <div class="progress-list-item-main">
                <h5 class="uppercase">Concise Communication</h5>
                <div class="progress-list-item-line"></div>
              </div>
            </router-link>
          </div>
          <div class="progress-list-item">
            <router-link to="/">
              <img
                src="https://appen.nazwa.pl/hardlight/projekty/ex2/win-2.jpg"
                class="img-fluid"
                alt="Responsive image"
              />
              <div class="progress-list-item-main">
                <h5 class="uppercase">How to win more clients</h5>
                <div class="progress-list-item-line">
                  <span class="text-purple">10%</span>
                  <mdb-progress :height="5" :value="10" />
                </div>
              </div>
            </router-link>
          </div>-->
        </mdb-col>
      </mdb-row>
    </mdb-container>

    <Footer></Footer>
  </div>
</template>

<script>
import Nav from "../components/Nav";
import Footer from "../components/Footer";
import firebase from "firebase/app";
import moment from "moment";
import {
  mdbContainer,
  mdbRow,
  mdbCol,
  mdbCard,
  mdbCardImage,
  mdbCardBody,
  mdbCardTitle,
  mdbCardText,
  mdbCardFooter,
  mdbBtn,
  mdbBadge,
  mdbIcon,
  mdbProgress
} from "mdbvue";
import { store } from "../store";

export default {
  name: "Profile",
  data: function() {
    return {
      emailFromStore: store.getters.getUser.email,
      progressTrackingOfMine: [], //used for progress presenting
      courses: [], //used for progress presenting
      usernameBigLabel: "nobody",
      userJoinedDateFromProfile: null,
      userProfileObjectFromFirestore: {},
      twoLettersCircleInterior: "__",
      yourProgressImages: [
        "https://appen.nazwa.pl/hardlight/projekty/ex2/listening.jpg",
        "https://appen.nazwa.pl/hardlight/projekty/ex2/presentation.jpg",
        "https://appen.nazwa.pl/hardlight/projekty/ex2/win-2.jpg",
        "https://appen.nazwa.pl/hardlight/projekty/ex2/listening.jpg",
        "https://appen.nazwa.pl/hardlight/projekty/ex2/presentation.jpg",
        "https://appen.nazwa.pl/hardlight/projekty/ex2/win-2.jpg",
        "https://appen.nazwa.pl/hardlight/projekty/ex2/listening.jpg",
        "https://appen.nazwa.pl/hardlight/projekty/ex2/presentation.jpg",
        "https://appen.nazwa.pl/hardlight/projekty/ex2/win-2.jpg",
        "https://appen.nazwa.pl/hardlight/projekty/ex2/listening.jpg",
        "https://appen.nazwa.pl/hardlight/projekty/ex2/presentation.jpg",
        "https://appen.nazwa.pl/hardlight/projekty/ex2/win-2.jpg",
        "https://appen.nazwa.pl/hardlight/projekty/ex2/listening.jpg",
        "https://appen.nazwa.pl/hardlight/projekty/ex2/presentation.jpg",
        "https://appen.nazwa.pl/hardlight/projekty/ex2/win-2.jpg",
        "https://appen.nazwa.pl/hardlight/projekty/ex2/listening.jpg",
        "https://appen.nazwa.pl/hardlight/projekty/ex2/presentation.jpg",
        "https://appen.nazwa.pl/hardlight/projekty/ex2/win-2.jpg"
      ],
      yourProgressData: [], //idea courses with progress info in this structure
      yourProgressPercent: []
    };
  },
  computed: {
    getUserPhotourl: function() {
      return store.getters.getAvatarurl &&
        store.getters.getAvatarurl !== "" &&
        store.getters.getAvatarurl !== undefined
        ? store.getters.getAvatarurl
        : "";
    }
  },
  created() {
    this.mthfillProfileDataOnCreated();

    this.mthfillProgressData();

    //this.mthFillProgressPercents();

    this.mthFillCourses();
    this.mthFillProgressTrackingOfMine();
  },
  methods: {
    mthFillCourses() {
      var refcourses = firebase.firestore().collection("courses");

      refcourses.onSnapshot(querySnapshot => {
        this.courses = [];
        querySnapshot.forEach(doc => {
          this.courses.push({
            firedata: doc.data()
          });
        });
        //console.log(this.courses);
      });
    },

    mthGetProgress(courseslug) {
      var toret = 0.001;

      var coursename = courseslug
        .replace("-", " ")
        .replace("-", " ")
        .replace("-", " ")
        .replace("-", " ")
        .replace("-", " ")
        .replace("-", " ")
        .replace("-", " ")
        .replace("-", " ")
        .replace("-", " ")
        .replace("-", " ");

      var licznik = this.mthGetSumOfVideosProgressesByCoursname(coursename);
      var mianownik = this.mthGetCourseTotalMinutesByName(coursename);

      if (mianownik === 0) return 0;
      if (licznik < 5) return 0;

      //console.log("licznik: " + licznik);
      //console.log("mianownik: " + mianownik);

      toret = (licznik * 100) / mianownik;

      if (toret > 100) return 100;
      if (toret < 0) return 0;

      toret = Math.round(toret);

      if (toret > 98) toret = 100;

      return toret;
    },
    mthGetSumOfVideosProgressesByCoursname(coursename) {
      var toret = 0.00000001;

      this.progressTrackingOfMine.forEach(t => {
        //console.log(t.firedata);

        if (t && t.firedata && t.firedata.courseslug && t.firedata.event) {
          let cname = t.firedata.courseslug
            .replace("-", " ")
            .replace("-", " ")
            .replace("-", " ")
            .replace("-", " ")
            .replace("-", " ")
            .replace("-", " ")
            .replace("-", " ")
            .replace("-", " ")
            .replace("-", " ")
            .replace("-", " ");
          if (cname === coursename && t.firedata.event.seconds)
            toret += t.firedata.event.seconds;
        }
      });

      return toret;
    },
    mthGetCourseTotalMinutesByName(coursename) {
      let totalminutes = 0; //to not divide by 0 ;)
      //console.log('arg is'+coursename)

      this.courses.forEach(c => {
        if (
          c.firedata.name === coursename &&
          c.firedata.newOrEditedCourseDetails
        ) {
          c.firedata.newOrEditedCourseDetails.forEach(d => {
            if (d.type && d.type === "video") {
              if (d && d.data && d.data.data && d.data.data.vimeoduration) {
                totalminutes += d.data.data.vimeoduration;
              }
            }
          });
        }
      });

      return totalminutes;
    },

    mthFillProgressTrackingOfMine() {
      var refProgressTracking = firebase
        .firestore()
        .collection("progressTracking")
        .where("userEmail", "==", this.$store.getters.getUser.email);

      refProgressTracking.onSnapshot(querySnapshot => {
        this.progressTrackingOfMine = [];
        querySnapshot.forEach(doc => {
          this.progressTrackingOfMine.push({
            firedata: doc.data()
          });
        });
        //console.log(this.progressTrackingOfMine);
      });
      return 0.001;
    },

    mthConstructLinkToCourse(slug) {
      //console.log("will construct to " + vid);
      return "/course/" + slug;
    },
    mthGetProgressBySlug(slug) {
      /*       console.log(
        "%cmthGetProgressBySlug started for " + slug,
        "color: green;"
      ); */

      let toret = 0.00000001;
      let counter = 0;

      this.yourProgressPercent.forEach(el => {
        if (el.slug !== undefined && el.slug == slug) {
          counter++;
          //if (el.vimeoidended !== undefined) {
          //ignoring
          //console.log("adding 100.001");
          //toret += 100.001;
          //} else

          if (el.vimeoid !== undefined && el.event.percent !== undefined) {
            //console.log("adding " + el.event.percent * 100);

            toret += el.event.percent;
          }
        }
      });

      if (counter == 0) return 0;

      toret = (toret * 100) / counter;

      if (toret > 98) toret = 100;

      return toret;
    },
    mthFillProgressPercents() {
      /*       console.log(
        "%mthFillProgressPercents will fill percents using email=" +
          this.emailFromStore,
        "color:green"
      ); */

      const toret = 0;

      var snap = firebase
        .firestore()
        .collection("progressTracking")
        .where("userEmail", "==", this.emailFromStore)
        //.where("courseslug", "==", slug)
        .get()
        .then(result => {
          result.forEach(doc => {
            //console.log("returning 3 for " + slug);
            //this.toret = 3;
            this.yourProgressPercent.push({
              slug: doc.data().courseslug,
              vimeoid: doc.data().vimeoid,
              vimeoidended: doc.data().vimeoidended,
              event: doc.data().event
            });
          });
        })
        .then(() => {
          //console.log("now yourProgressPercent has items: ");
          //console.log(this.yourProgressPercent);
        });

      return toret;
    },
    mthName2Slug(name) {
      return name
        .replace(" ", "-")
        .replace(" ", "-")
        .replace(" ", "-")
        .replace(" ", "-")
        .replace(" ", "-")
        .replace(" ", "-")
        .replace(" ", "-")
        .replace(" ", "-")
        .replace(" ", "-")
        .replace(" ", "-")
        .replace(" ", "-")
        .replace(" ", "-")
        .replace(" ", "-")
        .replace(" ", "-");
    },
    mthfillProgressData() {
      //console.log("mthfillProgressData: started");

      let refcourses = firebase.firestore().collection("courses");

      refcourses.onSnapshot(querySnapshot => {
        querySnapshot.forEach(doc => {
          this.yourProgressData.push({
            courseFriendlyName: doc.data().name,
            courseSlug: this.mthName2Slug(doc.data().name)
          });
        });
      });

      //console.log("%cmthfillProgressData: data is", "color:orange");
      //console.log(this.yourProgressData);
    },
    mthfillProfileDataOnCreated() {
      let userProfileDocRef = firebase
        .firestore()
        .collection("usersProfiles")
        .doc(store.getters.getUser.email);

      var userProfileDoc = userProfileDocRef
        .get()
        .then(doc => {
          if (!doc.exists) {
            /*             console.log(
              "userProfileDoc not exists for " + store.getters.getUser.email
            ); */
          } else {
            //console.log("userProfileDoc data:");
            this.userProfileObjectFromFirestore = doc.data();

            this.userJoinedDateFromProfile = 0;
            if (doc.data().joinedDate !== undefined)
              this.userJoinedDateFromProfile = moment(
                doc.data().joinedDate.seconds * 1000
              ).format("LLL");

            //console.log(this.userProfileObjectFromFirestore);
          }
        })
        .catch(err => {
          //console.log("userProfileDoc - Error getting document", err);
        });

      //result data
      this.usernameBigLabel = store.getters.getUser.email.split("@")[0];
      this.twoLettersCircleInterior = store.getters.getUser.email.substr(0, 2);
      //this.userJoinedDateFromProfile = moment(this.userProfileObjectFromFirestore.joinedDate).format("LTS");
    }
  },
  components: {
    Nav,
    Footer,
    mdbContainer,
    mdbRow,
    mdbCol,
    mdbCard,
    mdbCardImage,
    mdbCardBody,
    mdbCardTitle,
    mdbCardText,
    mdbCardFooter,
    mdbBtn,
    mdbBadge,
    mdbIcon,
    mdbProgress
  }
};
</script>

<style>
@import url("https://use.typekit.net/lel8wuy.css");
</style>
